/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Iframe from 'react-iframe';
import {
  Grid, Card, CardContent,
} from '@material-ui/core';
// import * as QuickSightEmbedding from 'amazon-quicksight-embedding-sdk';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SearchIcon from '@material-ui/icons/Search';
import Alert from '@material-ui/lab/Alert';
import Loader from 'react-loader-spinner';
import PropTypes from 'prop-types';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import NoDashboard from '../shared/NoDashboard';
import { reportErrorMessage, searchErrorMessage } from '../../constants/Constants';
import useStyles from '../style';

const Dashboard = (props) => {
  const classes = useStyles();
  const {
    dashboardUrl,
    isDLSending,
    dLError,
    isDURLsSending,
    dashboardListData,
    handleSearch,
    searchValue,
    isSearchError,
    reportName,
    reportDesc,
    isDLSuccess,
    uRLsError,
  } = props;


  const getDashboards = () => {
    if (dashboardUrl) {
      return (
        <CardContent className={classes.mainContainerColor}>
          <Iframe
            url={dashboardUrl + '&printEnabled=true'}
            width="100%"
            height="1600px"
            id="iframeId"
            className={classes.iFrame}
            display="initial"
            position="relative"
            frameBorder="0"
          />
        </CardContent>
      );
    }
    return null;
  };
  let searchOptions = [];
  if (dashboardListData && Array.isArray(dashboardListData)) {
    searchOptions = dashboardListData;
  }
  return (
    <>
      <div className={classes.dashboardRoot}>
        <div className={classes.divContent}>
          <h1 className={classes.divContentH2}>{reportName}</h1>
          <h3 className={classes.divContentH3}>{reportDesc}</h3>
          <div className="search-field">
            <Grid container spacing={1} alignItems="flex-end">
              <Grid item>
                <SearchIcon />
              </Grid>
              <Grid item xs={10}>
                <Autocomplete
                  value={searchValue}
                  onChange={(event, newValue) => handleSearch(event, newValue)}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  id="free-solo-with-text-demo"
                  options={searchOptions}
                  getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                      return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                      return option.inputValue;
                    }
                    // Regular option
                    return option.Name;
                  }}
                  renderOption={(option) => option.Name}
                  freeSolo
                  renderInput={(params) => (
                    <TextField {...params} label="Search Here ..." />
                  )}
                  disabled={isDLSending}
                />
              </Grid>
            </Grid>
          </div>
        </div>
        <Grid container spacing={2} justify="space-evenly">
          <Grid item xs={12}>
            <Card className={classes.mainContainerColor}>
              <Loader
                type="Grid"
                color="#FFBF00"
                secondaryColor="#2d2d2d"
                height={100}
                width={100}
                visible={isDLSending || isDURLsSending}
                className="loader"
              />
              {!isSearchError && uRLsError && (
                <Grid item md={10} sm={10} xs={12} className={classes.userGuide}>
                  <Alert
                    variant="filled"
                    severity="error"
                  >
                    {reportErrorMessage}
                  </Alert>
                </Grid>
              )}
              {dLError && <NoDashboard />}
              {isDLSuccess && (dashboardListData === null || !Array.isArray(dashboardListData) || dashboardListData.length === 0) && <NoDashboard />}
              {isSearchError && <div className={classes.searchReportError}><span>{searchErrorMessage}</span></div>}
              {!isSearchError && getDashboards()}
            </Card>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

/** Required function and props with the proptypes */
Dashboard.propTypes = {
  dashboardUrl: PropTypes.string.isRequired,
  isDLSending: PropTypes.bool.isRequired,
  dLError: PropTypes.bool.isRequired,
  isDURLsSending: PropTypes.bool.isRequired,
  dashboardListData: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  handleSearch: PropTypes.func.isRequired,
  searchValue: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    DashboardId: PropTypes.string,
    Name: PropTypes.string,
  })]),
  reportName: PropTypes.string,
  reportDesc: PropTypes.string,
  isSearchError: PropTypes.bool,
  isDLSuccess: PropTypes.bool,
  uRLsError: PropTypes.bool,
};

export default Dashboard;
